import { useLocation, useParams } from 'react-router-dom';
import { useAppRoutes } from 'hx-util';
import { findRouteIndex } from '../functions';
import { useMemo } from 'react';
export var usePathIndex = function () {
    var id = useParams().id;
    var pathname = useLocation().pathname;
    var pathSegments = useMemo(function () { return pathname.split('/'); }, [pathname]);
    var path = pathSegments[pathSegments.length - 1];
    var basePath = pathSegments[pathSegments.length - 2];
    var appRoutes = useAppRoutes();
    var indexByAppRoute = useMemo(function () { return findRouteIndex(appRoutes, path); }, [appRoutes, path]);
    var pathIndex = (id && +id) || indexByAppRoute;
    // if (id === undefined && indexByAppRoute === -1) throw 'Invalid ID or path';
    return { pathIndex: pathIndex, pathSegments: pathSegments, path: path, basePath: basePath };
};
export default usePathIndex;
